export default "__VITE_ASSET__BykP9cbs__"